<template>
  <BaseExtractedDetails 
    :sections="sections" 
    :has-data="hasData"
    :data="data"
  />
</template>

<script>
import BaseExtractedDetails from './BaseExtractedDetails.vue'

export default {
  name: 'EmiratesIDDetails',
  components: {
    BaseExtractedDetails
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasData() {
      return this.data && Object.keys(this.data).length > 0;
    },
    
    sections() {
      if (!this.data) return [];
      
      return [
        {
          title: 'Emirates ID Information',
          icon: 'las la-id-card',
          type: 'info-grid',
          fields: [
            {
              key: 'card_info.id_number',
              label: 'ID Number',
              format: 'text'
            },
            {
              key: 'personal_info.full_name_english',
              label: 'Full Name',
              format: 'text'
            },
            {
              key: 'personal_info.date_of_birth',
              label: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'personal_info.nationality',
              label: 'Nationality',
              format: 'text'
            },
            {
              key: 'personal_info.gender',
              label: 'Gender',
              format: 'text'
            },
            {
              key: 'card_info.expiry_date',
              label: 'Expiry Date',
              format: 'date'
            }
          ]
        }
      ];
    }
  }
}
</script>
